module.exports = __webpack_public_path__ + "img/pic_3.76e77a35.png";